import { Button } from "antd";
import React from "react";
import { Modal } from "react-bootstrap";
import { LimitCrossIcon } from "../../constants/svg";
import { Assets } from "../../constants/images";
import { useNavigate } from "react-router-dom";

const UserLimitModal = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="mainUserLimit"
        dialogClassName="subMainUserList userListModal"
      >
        <Modal.Body>
          <div
            className="headerCrossIcon cursor-pointer"
            onClick={props.onHide}
          >
            <LimitCrossIcon />
          </div>
          <div className="subModalContent">
            <img
              src={Assets.RocketModalImg}
              alt="rocket"
              className="img-fluid"
            />
            <h3>Looks like you’re growing!</h3>
            <p>
              You’ve reached the maximum number of users on your current plan.
              <br /> Please upgrade your subscription to add new users.
            </p>
            <div className="buttonDiv">
              {!props.suggestions ? (
                <Button
                  className="greyTransBg"
                  onClick={() => {
                    props.onHide();
                    navigate("/team/members");
                  }}
                >
                  Manage Members
                </Button>
              ) : null}
              <Button
                className="purpleBg"
                onClick={() => {
                  props.onHide();
                  navigate("/settings/billing");
                }}
              >
                Upgrade Plan
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserLimitModal;
